import { TInitialState } from '../reducer/initialState';

export type TGetAddressState = {
    selectedAddress: string,
    suggestionSelected: boolean,
    isLoading: boolean,
}

const getAddressState = (state: TInitialState): TGetAddressState => {
    return {
        selectedAddress: state.address,
        suggestionSelected: state.suggestionSelected,
        isLoading: state.isLoading,
    };
};

export default getAddressState;
